import React from 'react';
import img from '../images/Web.jpg'; 
import img2 from '../images/DMS.jpg';
import img3 from '../images/Testing.jpg';
import img4 from '../images/consultation.jpg';

const Services = () => {
  const services = [
    {
      img: img,
      title: 'Web Development',
      desc: 'We design and build modern, high-performing web applications tailored to your business needs. Our solutions are mobile-friendly, secure, and scalable, ensuring a smooth user experience across devices. From intuitive interfaces to powerful back-end systems, we help businesses create digital platforms that attract customers and deliver lasting value.',
    },
    {
      img: img2,
      title: 'Dealer Management System',
      desc: 'We develop comprehensive dealer management systems that simplify supply chain operations and improve collaboration across networks. Our solutions provide visibility, streamline workflows, and support real-time data sharing, enabling businesses to boost efficiency, strengthen dealer relationships, and scale operations with confidence.',
    },
    {
      img: img3,
      title: 'Software Testing',
      desc: 'We help businesses deliver seamless digital experiences by ensuring their applications are reliable and high performing. Through a combination of manual and automated testing, we identify issues to improve usability, and provide the confidence that your software consistently meets user expectations.',
    },
    {
      img: img4,
      title: 'IT Consultation',
      desc: 'We provide expert IT consulting services that align technology with your business strategy. By assessing your current systems, identifying opportunities, and recommending tailored solutions, we help organizations optimize performance, reduce costs, and adopt innovations that drive long-term growth and competitiveness.',
    },
  ];

  return (
    <section
      id="services"
      className="relative bg-gradient-to-b from-[#f3f8fc] to-[#e1eef7] py-16 px-6 lg:px-20"
    >
      {/* Section Header */}
      <div className="text-center mb-12" data-aos="fade-up">
        <h2 className="text-4xl font-bold text-[#15467a] uppercase tracking-wide inline-block relative">
          Solution & Services
          <div className="h-1 bg-[#15467a] mt-3 rounded-full w-full"></div>
        </h2>
        <p className="mt-6 text-lg text-gray-700 font-medium max-w-3xl mx-auto">
          We are committed to delivering reliable, secure, and scalable solutions 
          that drive growth and long-term success for our clients.
        </p>
      </div>

      {/* Services Grid */}
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {services.map((service, index) => (
          <div
            key={index}
            data-aos="zoom-in"
            data-aos-delay={index * 200}
            className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition duration-500 group"
          >
            <img
              src={service.img}
              alt={service.title}
              className="w-full h-52 object-cover rounded-xl group-hover:scale-110 transition duration-700"
            />
            <div className="p-6 text-center">
              <h3 className="text-2xl font-semibold text-[#15467a] mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 text-md leading-relaxed">
                {service.desc}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Build & Collaborate Section */}
      <div className="mt-20 grid lg:grid-cols-2 gap-12 items-center">
        <div className="text-center lg:text-left flex flex-col items-center lg:items-start" data-aos="fade-right">
          <h3 className="text-3xl font-bold text-[#15467a] mb-4 flex items-center gap-3">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7 text-[#15467a]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6V4m0 16v-2m8-6h2M4 12H2m15.364 6.364l1.414 1.414M6.343 6.343L4.929 4.929m12.02 0l1.414 1.414M6.343 17.657l-1.414 1.414" />
            </svg>
            We <span className="font-black">Build</span>
          </h3>
          <p className="text-lg text-gray-700 font-medium leading-relaxed">
            With over 18 years of experience in web development, dealer management systems, 
            software testing, and IT consulting, we build tailored solutions that streamline 
            operations, enhance user experiences, and drive measurable business growth.
          </p>
        </div>

        <div className="text-center lg:text-left flex flex-col items-center lg:items-start" data-aos="fade-left">
          <h3 className="text-3xl font-bold text-[#15467a] mb-4 flex items-center gap-3">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7 text-[#15467a]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5V4H2v16h5m10-4l-4-4m0 0l-4-4m4 4H9" />
            </svg>
            We <span className="font-black">Collaborate</span>
          </h3>
          <p className="text-lg text-gray-700 font-medium leading-relaxed">
            We collaborate closely with your team—offering development, testing, and ongoing 
            consultation—to ensure your technology evolves with your business and continues 
            delivering long-term value.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Services;
